import APILibrary, { ClassExtender, GConstructor, GenerateResource } from './APILibrary';
import { EmployerProfileResource } from 'util/resources/EmployerProfile';
import { Base } from 'active-resource';

/**
 * Support interfaces
 */
interface Slot {
  slot: string;
  duration: number;
}
interface Day {
  date: string;
  freeSlots: Slot[];
}

/**
 * Relationship classes
 */
export class AvailabilityAttributes {
  days: Day[] = null;
  id: string = null;
}

export class AvailabilityBelongsTo {
  employerProfile: () => EmployerProfileResource = () => new EmployerProfileResource();
}

export class AvailabilityHasOne {}

export class AvailabilityHasMany {}

/**
 * Utility interfaces
 */
export interface AvailabilityMethods {}

export interface AvailabilityInterface
  extends AvailabilityAttributes,
    AvailabilityBelongsTo,
    AvailabilityHasOne,
    AvailabilityHasMany,
    AvailabilityType {}

type AvailabilityType = GConstructor<AvailabilityInterface>;

export interface AvailabilityResource
  extends Base<AvailabilityAttributes>,
    AvailabilityInterface,
    AvailabilityMethods {}

/**
 * Resource methods
 */
const BaseClass = () =>
  class extends GenerateResource<AvailabilityAttributes>({
    queryName: 'interview_slots',
    className: 'Availability',
    AttributesClass: AvailabilityAttributes,
    BelongsToClasses: [
      {
        Klass: AvailabilityBelongsTo,
      },
    ],
    HasOneClasses: [
      {
        Klass: AvailabilityHasOne,
      },
    ],
    HasManyClasses: [
      {
        Klass: AvailabilityHasMany,
      },
    ],
  }) {};

export const AvailabilityResourceClass = <TBase extends AvailabilityType>(
  BaseConstructor: TBase,
): TBase =>
  class extends BaseConstructor implements AvailabilityMethods {
    static queryName = 'interview_slots';
    static className = 'Availability';
  };

export class AvailabilityResource extends ClassExtender<AvailabilityInterface>(
  BaseClass,
  AvailabilityResourceClass,
) {}

/**
 * Resource instance
 */
export const Availability = APILibrary.createResource<AvailabilityResource>(AvailabilityResource);
